module.exports = __webpack_public_path__ + "img/naturalbeige@2x.e03d0da.jpg";